
import React, { useState , useEffect} from 'react';
import { EventStatePayload, setVoiceData, setDigitalAvatar } from '../../../../../redux/eventSlice';
import { RootState } from '../../../../../redux/store';

import InputField from 'components/fields/InputField';
import { useDispatch, useSelector } from 'react-redux';

type CreateEventProps = {
  eventObject?: EventStatePayload;
};

type InteractionMode = 'onlyVoice' | 'digitalavatar';

const InteractionModeSelector = ({ eventObject }: CreateEventProps) => {

  const dispatch = useDispatch();

  const voiceId = useSelector((state: RootState) => state.event.payload.voiceData?.voiceId || '');
  const voiceName = useSelector((state: RootState) => state.event.payload.voiceData?.voiceName || '');

  const avatarId = useSelector((state: RootState) => state.event.payload.digitalAvatar?.AvatarId || '');
  const selectedStt = useSelector((state: RootState) => state.event.payload.voiceData?.stt || '');
  const selectedTts = useSelector((state: RootState) => state.event.payload.voiceData?.tts || '');
  const preferredLanguage = useSelector((state: RootState) => state.event.payload.voiceData?.language || '');
  console.log(voiceId);

  const handleSttChange = (e: React.ChangeEvent<HTMLSelectElement>)  => {
    const value = e.target.value;
    dispatch(setVoiceData({
      voiceId: voiceId,
      voiceName: voiceName,
      stt: value,
      tts: selectedTts,
      language: preferredLanguage,
    }));
  }

  const handleTtsChange = (e: React.ChangeEvent<HTMLSelectElement>)  => {
    const value = e.target.value;
    dispatch(setVoiceData({
      voiceId: voiceId,
      voiceName: voiceName,
      stt: selectedStt,
      tts: value,
      language: preferredLanguage,
    }));
  }

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>)  => {
    const value = e.target.value;
    dispatch(setVoiceData({
      voiceId: voiceId,
      voiceName: voiceName,
      stt: selectedStt,
      tts: selectedTts,
      language: value,
    }));
  }
  const handleVoiceNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    console.log(value);
 
      dispatch(setVoiceData({
        voiceId: value,
        voiceName: value,
        stt: selectedStt,
        tts: selectedTts,
        language: preferredLanguage,
      }));
  };
    const [mode, setMode] = useState<InteractionMode>('onlyVoice');

    useEffect(() => {
      if (eventObject?.voiceData) {
        dispatch(setVoiceData(eventObject.voiceData));
      }

      if (eventObject?.digitalAvatar?.AvatarId) {
        dispatch(setDigitalAvatar({
          avatarId: eventObject.digitalAvatar.AvatarId,
          voiceId: eventObject.digitalAvatar.voiceId || ''
        }));
        setMode('digitalavatar');
      }
    }, [dispatch, eventObject]);


  const handleModeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.value as InteractionMode;
    setMode(selected);

    if (selected === 'onlyVoice') {
      dispatch(setDigitalAvatar({ avatarId: '', voiceId: '' }));
    }
  };

  const handleVoiceIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    console.log(value);
    if (mode === 'onlyVoice') {
      dispatch(setVoiceData({
        voiceId: value,
        voiceName: voiceName,
        stt: selectedStt,
        tts: selectedTts,
        language: preferredLanguage,
      }));
    } else {
      dispatch(setDigitalAvatar({ avatarId, voiceId: value }));
    }
  };

  const handleAvatarIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setDigitalAvatar({ avatarId: e.target.value, voiceId }));
  };
  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <div>
        <div className="flex items-center mb-4">
          <input
            type="radio"
            id="onlyVoice"
            name="interactionMode"
            value="onlyVoice"
            checked={mode === 'onlyVoice'}
            onChange={handleModeChange}
            className="mr-2"
          />
          <label htmlFor="onlyVoice" className="mr-4">
            Only Voice AI
          </label>

          <input
            type="radio"
            id="digitalavatar"
            name="interactionMode"
            value="digitalavatar"
            checked={mode === 'digitalavatar'}
            onChange={handleModeChange}
            className="mr-2"
            disabled
          />
          <label htmlFor="digitalavatar">Digital Avatar With Voice AI</label>
        </div>

        {mode === 'onlyVoice' && (
          <div>
          <div className="mt-4">
            <InputField
              extra="mb-3"
              label="Voice ID *"
              placeholder="Enter Voice ID"
              id="voiceId"
              type="text"
              value={voiceId}
              onChange={handleVoiceIdChange}
            />
          </div>
          <div className="mt-4">
            <InputField
              extra="mb-3"
              label="Voice Name *"
              placeholder="Enter Voice Name"
              id="voiceName"
              type="text"
              value={voiceName}
              onChange={handleVoiceNameChange}
            />
          </div>
          <div className="mt-4">
          <label htmlFor="stt" className="block text-sm font-medium text-gray-700  bold mb-1">
      Select STT Provider *
    </label>
    <select
      id="stt"
      value={selectedStt}
      onChange={handleSttChange}
      className="w-full border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200"
    >
      <option value="">-- Select STT --</option>
      <option value="deepgram">Deepgram</option>
      <option value="google">Google</option>
      <option value="elevenlabs">ElevenLabs</option>
      <option value="openai">OpenAI</option>
    </select>
          </div>
          <div className="mt-4">
    <label htmlFor="tts" className="block text-sm font-medium text-gray-700 mb-1">
      Select TTS Provider *
    </label>
    <select
      id="tts"
      value={selectedTts}
      onChange={handleTtsChange}
      className="w-full border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200"
    >
      <option value="">-- Select TTS --</option>
      <option value="elevenlabs">ElevenLabs</option>
      <option value="google">Google</option>
      <option value="deepgram">Deepgram</option>
      <option value="openai">OpenAI</option>
    </select>
  </div>
  <div>
    <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-1">
      Preferred Language *
    </label>
    <select
      id="language"
      value={preferredLanguage}
      onChange={handleLanguageChange}
      className="w-full border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200"
    >
      <option value="">-- Select Language --</option>
      <option value="telugu">Telugu</option>
      <option value="hindi">Hindi</option>
      <option value="english">English</option>
      <option value="german">German</option>
      <option value="french">French</option>
    </select>
  </div>
          </div>

        )}

        {mode === 'digitalavatar' && (
          <div className="mt-4">
            <InputField
              extra="mb-3"
              label="Digital Avatar ID *"
              placeholder="Enter Digital Avatar ID"
              id="avatarId"
              type="text"
              value={avatarId}
              onChange={handleModeChange}
              disabled
            />
            <InputField
              extra="mb-3"
              label="Voice ID *"
              placeholder="Enter Voice ID"
              id="voiceId"
              type="text"
              value={voiceId}
              onChange={handleVoiceIdChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InteractionModeSelector;
